export default __webpack_public_path__ + "static/media/Warning.3b7a6686.svg";